// extracted by mini-css-extract-plugin
export default {"card":"_card_card__wAdI2","type":"_card_type__0l1Oe"};